import { useState } from 'react';
import insertUrlParams from '../utils/insertUrlParams';
import getUrlParam from '../utils/getUrlParam';

function getUrlRiverID() {
  let params = {
    river_id: getUrlParam('river_id') || '',
  };
  if (Object.values(params).includes('')) {
    return undefined;
  }
  return params;
}

export default function useRiverID() {
  const [riverID, setRiverID] = useState(getUrlRiverID());

  const handleRiverIDChange = (e) => {
    setRiverID(e);
    if (e !== undefined) {
      insertUrlParams(e);
    } else {
      insertUrlParams({
        river_id: '',
      });
    }
  };

  return { riverID, handleRiverIDChange };
}
